import './index.scss';
import AuthenticatedPage from '../../common/components/authenticated-page';
import FamilyAvailability from './familyAvailability';
import React from 'react';

export default props => (
    <AuthenticatedPage className="atp-page family-availability-page">
        <FamilyAvailability {...props} />
    </AuthenticatedPage>
);